import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../../utils/api";
import "./Permissions.css";

const Permissions = () => {
  const [fetchedData, setFetchedData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { id } = useParams(); // Role ID

  useEffect(() => {
    handlePermission();
  }, []);

  async function handlePermission() {
    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = "viewPermissionDetails";

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("role", id);

    try {
      setLoading(true);
      const response = await api.post("permission/permissionCurl", fd);
      // console.log("Response from API:", response.data);

      if (response.data.success) {
        setFetchedData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching permissions:", error);
    } finally {
      setLoading(false);
    }
  }

  const handleSelectAllChange = (index) => {
    setFetchedData((prevData) =>
      prevData.map((item, i) => {
        if (i === index) {
          // Check if all permissions are already selected
          const allChecked =
            item.is_add === "1" &&
            item.is_edit === "1" &&
            item.is_delete === "1" &&
            item.is_view === "1";

          return {
            ...item,
            is_add: allChecked ? "0" : "1",
            is_edit: allChecked ? "0" : "1",
            is_delete: allChecked ? "0" : "1",
            is_view: allChecked ? "0" : "1",
          };
        }
        return item;
      })
    );
  };

  const handleCheckboxChange = (index, field) => {
    setFetchedData((prevData) =>
      prevData.map((item, i) =>
        i === index
          ? { ...item, [field]: item[field] === "1" ? "0" : "1" }
          : item
      )
    );
  };

  async function handleSubmit() {
    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = "updatePermission";

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("role", id);

    // Convert fetchedData into an array format
    const permissions = fetchedData.map((item) => ({
      submenu_id: item.id, // Assuming 'id' is submenu_id
      is_add: item.is_add,
      is_edit: item.is_edit,
      is_view: item.is_view,
      is_delete: item.is_delete,
    }));

    // Log the permissions array before submitting
    // console.log("Submitting permissions array:", permissions);

    // Append each permission item separately
    permissions.forEach((permission, index) => {
      Object.keys(permission).forEach((key) => {
        fd.append(`permissions[${index}][${key}]`, permission[key]);
      });
    });

       for (let pair of fd.entries()) {
        console.log(pair[0] + ": " + pair[1]);
      }

    try {
      setLoading(true);
      const response = await api.post("permission/permissionCurl", fd);
      // console.log("Response from API:", response.data);
    } catch (error) {
      console.error("Error updating permissions:", error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="dashboard-body">
      <div className="breadcrumb-with-buttons mb-24 flex-between flex-wrap gap-8">
        <div className="breadcrumb mb-24">
          <ul className="flex-align gap-4">
            <li>
              <Link
                to="/"
                className="text-gray-200 fw-normal text-15 hover-text-main-600"
              >
                Home
              </Link>
            </li>
            <li>
              <span className="text-gray-500 fw-normal d-flex">
                <i className="ph ph-caret-right"></i>
              </span>
            </li>
            <li>
              <span className="text-main-600 fw-normal text-15">
                Permissions
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="card mt-24">
  <div className="card-header table-responsive" style={{ padding: "10px" }}>
    <table className="table table-striped">
      <thead>
        <tr>
          <th className="h5 text-gray-300" scope="col">ID</th>
          <th className="h5 text-gray-300" scope="col">Menus</th>
          <th className="h5 text-gray-300" scope="col">Select All</th>
          <th className="h5 text-gray-300" scope="col">Add</th>
          <th className="h5 text-gray-300" scope="col">Edit</th>
          <th className="h5 text-gray-300" scope="col">Delete</th>
          <th className="h5 text-gray-300" scope="col">View</th>
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <tr>
            <td colSpan="7" className="text-center">Loading...</td>
          </tr>
        ) : fetchedData.length === 0 ? (
          <tr>
            <td colSpan="7" className="text-center text-primary fw-bold">
              Loading Permissions...
            </td>
          </tr>
        ) : (
          fetchedData.map((item, index) => (
            <tr key={item.id}>
              <td className="h6 mb-0 fw-medium text-gray-300" style={{ color: "black" }}>
                {index + 1}
              </td>
              <td className="h6 mb-0 fw-medium text-gray-300" style={{ color: "black" }}>
                {item.submenuName || `Menu ${item.id}`}
              </td>
              <td>
                <input
                  type="checkbox"
                  className="custom-checkbox"
                  checked={item.is_add === "1" && item.is_edit === "1" && item.is_delete === "1" && item.is_view === "1"}
                  onChange={() => handleSelectAllChange(index)}
                />
              </td>
              <td>
                <input type="checkbox" className="custom-checkbox" checked={item.is_add === "1"} onChange={() => handleCheckboxChange(index, "is_add")} />
              </td>
              <td>
                <input type="checkbox" className="custom-checkbox" checked={item.is_edit === "1"} onChange={() => handleCheckboxChange(index, "is_edit")} />
              </td>
              <td>
                <input type="checkbox" className="custom-checkbox" checked={item.is_delete === "1"} onChange={() => handleCheckboxChange(index, "is_delete")} />
              </td>
              <td>
                <input type="checkbox" className="custom-checkbox" checked={item.is_view === "1"} onChange={() => handleCheckboxChange(index, "is_view")} />
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>

  {/* Hide Save Button if there are no permissions */}
  {fetchedData.length > 0 && (
    <div className="card-footer">
      <button className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
        {loading ? "Saving..." : "Save Changes"}
      </button>
    </div>
  )}
</div>

    </div>
  );
};

export default Permissions;
